module.exports = __webpack_public_path__ + "img/share-twiter-hover.6b24d885.svg";